import Header from "../../components/public/header";
import Navigation from "../../components/public/navigation";
import Main from "../../components/public/sections/main";
import Halls from "../../components/public/hall";
import Footer from "../../components/public/footer";

export default () => {
  return (
    <>
      <Navigation />
      <Header />
      <Main pageHeading={"हॉल"} content={<Halls />} />
      <Footer />
    </>
  );
};
